import React from 'react';
import Style from './style.js';
import { jsx } from '@emotion/react';

var Thumbnails = _ref => {
  var {
    photoSrcs
  } = _ref;

  /**
   * Thumbnail images set with empty alt text because they are decorative.
   * Accessible Accordion functionality does not depend on these thumbnails.
   */
  var renderThumbnails = () => {
    if (photoSrcs.length === 0) {
      return null;
    }

    var firstThumbnail = jsx(Style.ImageContainer, null, jsx(Style.ThumbnailImage, {
      alt: "",
      src: photoSrcs[0]
    }));

    var secondThumbnail = null;

    if (photoSrcs.length === 2) {
      secondThumbnail = jsx(Style.ImageContainer, null, jsx(Style.ThumbnailImage, {
        alt: "",
        src: photoSrcs[1]
      }));
    } else if (photoSrcs.length > 2) {
      secondThumbnail = jsx(Style.MultiplesContainer, null, jsx(Style.MultiplesText, null, "+", photoSrcs.length - 1));
    }

    return jsx(React.Fragment, null, firstThumbnail, secondThumbnail);
  };

  return jsx(Style.Container, null, renderThumbnails());
};

export { Thumbnails };
